import React, { useState } from "react";
import { colors } from "../../../../../themes/Colors";

const NewSectionButton = ({
  backgroundColor,
  title,
  fontColor,
  active,
  onClick,
  open,
  onActiveClick,
  notBasic,
  dropDownMarker,
}) => {
  const [hover, setHover] = useState(false);
  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={active ? onActiveClick : onClick}
      style={{
        height: hover ? 55 : 50,
        width: "100%",
        display: "flex",
        backgroundColor: backgroundColor,
        alignItems: "center",
        transition: "all 0.3s",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          color: fontColor,
          fontSize: 16,
          fontWeight: "bold",
          marginLeft: 20,
        }}
      >
        {title}
      </div>
      <div style={{ flex: 1 }}></div>
      {notBasic ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            marginRight: 40,
          }}
        >
          <div
            style={{
              position: "absolute",
              height: dropDownMarker ? 4 : 25,
              width: 4,
              borderRadius: 4,
              backgroundColor: colors.white,
              opacity: dropDownMarker ? 0 : 1,
              transition: "all 0.3s",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              height: 4,
              width: 25,
              borderRadius: 4,
              backgroundColor: colors.white,
            }}
          ></div>
        </div>
      ) : (
        <div
          style={{
            height: hover ? 70 : 60,
            width: hover ? 70 : 60,
            borderRadius: "100%",
            backgroundColor: colors.greenLight,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: colors.white,
            fontSize: active ? 18 : hover ? (open ? 18 : 53) : open ? 18 : 50,
            fontWeight: "bold",
            marginRight: 10,
            transition: "all 0.3s",
          }}
        >
          {active ? (
            <div style={{ marginRight: 0 }}>ACTIVE</div>
          ) : (
            <div
              style={{
                marginBottom: open ? 0 : hover ? 10 : 7,
                transition: "all 0.3s",
              }}
            >
              {open ? "OPEN" : "+"}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NewSectionButton;
